import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isAuthenticated: false,
  user: null,
  profile: {}
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setLogin: (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload;
    },
    setLogout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
    },
    setProfile: (state, action) => {
      state.profile = action.payload
    }
  },
});

export const selectAuthToken = (state) => state?.auth?.user?.token;
export const { setLogin, setLogout, setProfile } = authSlice.actions;
export default authSlice.reducer;